import { SpamFill } from "components/icons/icn-spam-fill";
import { TextSpan } from "components/text-label";
import { useMemo } from "react";
import intl from "react-intl-universal";
import { formatNumber } from "utils/format";
import type { ExitSuggestions } from "../..";

import {
  ContentRow,
  PanelDetails as Details,
  Header,
  ItemWrapper,
  PairWrapper,
  PlantLabel,
  QuantityLabel,
} from "./styled";

interface PanelDetailsProps {
  exitSuggestions: ExitSuggestions[];
  unitOfMeasurement: string;
}
export const PanelDetails = (props: PanelDetailsProps) => {
  const { exitSuggestions, unitOfMeasurement } = props;

  const pairedSuggestions = useMemo(() => {
    const pairedSuggestionsTemp = [];
    for (let i = 0; i < exitSuggestions.length; i += 2) {
      pairedSuggestionsTemp.push(exitSuggestions.slice(i, i + 2));
    }
    return pairedSuggestionsTemp;
  }, [exitSuggestions]);

  return (
    <Details>
      <Header>
        <SpamFill size={16} color="var(--color-feedback-warning-300)" />
        <TextSpan
          color={"var(--color-feedback-warning-300)"}
          display={"inline"}
          style={{
            fontSize: "15px",
            fontWeight: "var(--font-weight-semibold)",
            marginLeft: "8px",
          }}
        >
          {intl.get("stocks.reservedTo").toUpperCase()}
        </TextSpan>
      </Header>
      <ContentRow>
        {pairedSuggestions.map((pair, pairIndex) => {
          const pairKey = pair.map((x) => `${x.DestinationPlant}-${x.Quantity}`).join("-");
          return (
            <PairWrapper key={pairKey}>
              {pair.map((x, index) => {
                return (
                  <ItemWrapper key={`${x.DestinationPlant}-${x.Quantity}-${pairIndex}-${index}`}>
                    <PlantLabel>
                      <TextSpan
                        color={"var(--color-neutral-900)"}
                        display={"inline"}
                        style={{
                          fontSize: "15px",
                          fontWeight: "var(--font-weight-regular)",
                        }}
                      >
                        {x.DestinationPlant}:
                      </TextSpan>
                    </PlantLabel>
                    <QuantityLabel>
                      <TextSpan
                        color={"var(--color-feedback-warning-300)"}
                        display={"inline"}
                        style={{
                          fontSize: "15px",
                          fontWeight: "700",
                          marginLeft: "4px",
                        }}
                      >
                        {formatNumber(x.Quantity)} {unitOfMeasurement}
                      </TextSpan>
                    </QuantityLabel>
                  </ItemWrapper>
                );
              })}
            </PairWrapper>
          );
        })}
      </ContentRow>
    </Details>
  );
};
